import { render } from "./lightbox-block.vue?vue&type=template&id=78f970f4"
import script from "./lightbox-block.vue?vue&type=script&lang=js"
export * from "./lightbox-block.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__